$(document).ready(function() {
    // DEBUG > show element with current focus
    // $('body').on('keypress', function(event) {
    //     console.log("%cTTG Debug", "background: #0080a3; color: #fff; padding: 5px;", $(document.activeElement));
    // });

    // Tooltips initialisieren
    $('[data-toggle="tooltip"]').tooltip();

    // if ($('[data-toggle="js-tooltip"]').length) {
    //     $('[data-toggle="js-tooltip"]').accessibleSimpleTooltipAria();
    // }

    // Lightbox
    var data_class = ".ttgNCEBildergalerie";
    if ($(".ttgNCEWrapper.ttgNCESlider").length) {
        data_class = ".ttgNCEWrapper.ttgNCESlider";
    }

    console.log('%cTTG Debug', 'background: #0080a3; color: #fff; padding: 5px;', $(data_class));
    var nextElement = $(data_class).data("next-element");
    var previousElement = $(data_class).data("previous-element");
    var close = $(data_class).data("close");

    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        var element = $(this);
        event.preventDefault();
        $(this).ekkoLightbox({
            alwaysShowClose: true,
            leftArrow: '<span class="fas fa-angle-left" aria-hidden="true"></span><p class="sr-only">' + previousElement + '</p>',
            rightArrow: '<span class="fas fa-angle-right" aria-hidden="true"></span><p class="sr-only">' + nextElement + '</p>',
            wrapping: false,
            onShown: function() {
                $(".ekko-lightbox").attr("aria-modal", true);
                $(".ekko-lightbox-nav-overlay a").attr("role", "button");
                $(".ekko-lightbox .close").html('<span class="fas fa-times" aria-hidden="true"></span><span class="sr-only">' + close + '</span>').removeAttr("aria-label");
            },
            onHidden: function() {
                element.focus();
            },
        });

    });

    // BackToTop
    $('.ttgBackToTop').click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
        return false;
    });
});
